module.exports = __webpack_public_path__ + "img/pass.e2b58405.png";